module.exports = __webpack_public_path__ + "img/stock.da8df873.jpg";